function SimpleLinkCard(props) {
    return (
        <a href={props.link}>
            <div className="transition-all shadow-xl hover:shadow-2xl hover:scale-105 rounded-3 px-15 py-12 flex flex-col items-center justify-center">
                <img className="w-24 mb-8" src={props.icon} alt="" />
                <span className="text-3xl font-bold">{props.name}</span>
            </div>
        </a>
    );
}

export default SimpleLinkCard;